export default __webpack_public_path__ + "static/media/PlanLogo.e42701b6.png";